const ContactConstant = {
    // General info / public-facing (used on non-authenticated pages)
    INFO_EMAIL: 'info@studyprepal.com',

    // Support / authenticated-user help (used on authenticated pages)
    SUPPORT_EMAIL: 'support@studyprepal.com',

    // Business / partnership inquiries
    BUSINESS_EMAIL: 'business@studyprepal.com',

    // Internal contact
    KHOA_VO_EMAIL: 'khoa.vo@studyprepal.com',
};

export default ContactConstant;
